import React from 'react';
import classNames from "classnames";
import styles from "./odds-tooltip.content.module.scss";
import {OptionOriginalRate} from "../../option-rates/option-original-rate";

export const OddsTooltipContentOriginalRate = ({option, controller, betsImpressionParams}) => {
  const {terms: {WEB_ORIGINAL_ODDS}} = controller;

  const rateProps = {
    option,
    controller,
    betsImpressionParams
  }

  return option.isOriginalRateValid ? <div className={classNames(styles.pre_match_rate)}>
    {
      `${WEB_ORIGINAL_ODDS}: `
    }
    <OptionOriginalRate {...rateProps}/>
  </div> : null
};
